// extracted by mini-css-extract-plugin
export var oMedia = "styles-module--o-media--916db";
export var oMedia__body = "styles-module--o-media__body--4e765";
export var oVerticalSpacing = "styles-module--o-vertical-spacing--68572";
export var oVerticalSpacingL = "styles-module--o-vertical-spacing--l--ec087";
export var shimmer = "styles-module--shimmer--2a015";
export var skeletonBox = "styles-module--skeletonBox--2bef2";